import apiClient from '../../../common/functions/api_axios_instance.function';
import { notify } from '../../../common/functions/react-toastify.function';

export const updateRoleAssignment = async (data) => {
  try {
    // Backend expects { id, user_id, role_id } in body
    const requestData = {
      id: data.id,
      user_id: data.user_id,
      role_id: data.role_id,
    };
    const response = await apiClient.put('/invoiceRoleManagement/update', requestData);
    return { success: true, data: response.data };
  } catch (error) {
    console.log(error);
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      'Failed to update role assignment';
    notify('error', errorMessage);
    return { success: false, error: errorMessage };
  }
};
